/* eslint-disable no-undef */
/* eslint-disable react/jsx-handler-names */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import ReactModal from 'react-modal';
import Button from '../button/button.jsx';
import CloseButton from './close-button.jsx';
import VideoShow from './video-show.jsx';
import style from './first-step.css';
import {scratchClick} from '../../utils/xes-analytice';
import {getDeviceStatus} from '../../utils';
import { getClassIds } from '../../lib/services/scratch-ser';
import Loader from '../loader/loader.jsx';

const limitLen = (maxlen, name) => {
    const limitNum = maxlen;
    const currentLen = name.length;
    return currentLen > limitNum;
};

class FirstStep extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleInputInfo',
            'clickShareHandle',
            'handleTextareaInfo',
            'handleData',
            'handleSwitchPublish',
            'handleVideoClick',
            'videoRef',
            'bigVideoRef',
            'handleBigVideoClose',
            'handelSwitchTagsActive',
            'handleCloseShareModal',
            'handleReupload'
        ]);
        // 如果有保存的项目名称和描述，使用它们初始化
        const savedTitle = props.savedProjectTitle || '';
        const savedDesc = props.savedProjectDesc || '';
        this.state = {
            shareTitle: savedTitle,
            selectedTab: '项目分享',
            shareDes: savedDesc,
            isDesNumLimit: limitLen(45, savedDesc),
            bigShow: false,
            isPublish: true,
            canShareToClass: null,
            labels: [
                {
                    key: 1,
                    label: '游戏',
                    active: false
                }, {
                    key: 2,
                    label: '故事',
                    active: false
                }, {
                    key: 3,
                    label: '音乐',
                    active: false
                }, {
                    key: 8,
                    label: '其他',
                    active: false,
                    filter: ['all']
                }]
            
        };


    }
    componentWillMount () {
        const userType = localStorage.getItem('XIAOHOUCODE_TEACHERTYPE')
        getClassIds({userType: userType && Number(userType)})
            .then((res)=>{
                const { data: { data, status } } = res;
                if (status === 200) {
                    this.setState({
                        canShareToClass: data && data.length > 0
                    })
                } else {
                    this.setState({ canShareToClass: false })
                }
            })
            .catch(()=>{
                this.setState({ canShareToClass: false })
            });
    }
    componentWillUnmount () {
        if (this.videoSrc) {
            URL.revokeObjectURL(this.videoSrc);
            this.videoSrc = null;
        }
    }

    handleInputInfo (e) {
        this.setState({
            shareTitle: e.target.value
        });
    }

    handleTextareaInfo (e) {
        this.setState({
            shareDes: e.target.value,
            isDesNumLimit: limitLen(45, e.target.value)
        });
    }

    handleData () {
        const {
            shareTitle,
            shareDes,
            isPublish,
            labels,
            canShareToClass
        } = this.state;
        if (canShareToClass === null) return;
        const {videoType, audioType, duration} = this.props;
        scratchClick('click_xiaohou_share_step4', {
            language: 'Scratch',
            editor: 'Scratch编辑器',
            scene: '社区创作',
            bundle_id: '',
            question_id: '',
            // eslint-disable-next-line react/prop-types
            content_type: this.props.blob ? '视频作品' : '纯项目作品',
            status: getDeviceStatus(videoType, audioType),
            video_duration: (duration / 1000).toFixed(1)
        });
        let tags = labels.filter(label => label.active).map(label => label.key);
        // 如果为空就为其他
        tags = tags.length === 0 ? [8] : tags;
        const params = Object.assign({}, {
            shareTitle: shareTitle || this.props.defaultTitle.substring(0, 20),
            shareDes: shareDes || '快来看看我的Scratch作品吧！',
            // eslint-disable-next-line react/prop-types
            isPublish: this.props.blob ? false : isPublish,
            tags
        });
        this.props.onClick(params);
    }

    handleSwitchPublish (event) {
        this.setState({
            isPublish: event.target.checked
        });
    }
    clickShareHandle(type) {
        this.setState({
            selectedTab: type
        });
        if (this.props.onSaveTab && typeof this.props.onSaveTab === 'function') {
            this.props.onSaveTab(type);
        }
        console.log(this.props)
        if (type === '视频录制') this.props.onResetShareStatus()

    }
    handleVideoClick () {
        this.setState({
            bigShow: true
        });
    }

    handleBigVideoClose () {
        this.setState({
            bigShow: false
        });
    }

    handelSwitchTagsActive (index) {
        return () => {
            const {labels} = this.state;
            labels[index].active = !labels[index].active;
            this.setState({
                labels: labels
            });
        };
    }
    videoRef (el) {
        this.video = el;
    }

    bigVideoRef (el) {
        this.bigVideo = el;
    }

    handleCloseShareModal () {
        this.props.onCloseModal();
    }

    handleReupload () {
        // 保存当前的项目名称和描述
        const { shareTitle, shareDes } = this.state;
        // 清理视频 URL，因为 blob 会被清空
        if (this.videoSrc) {
            URL.revokeObjectURL(this.videoSrc);
            this.videoSrc = null;
        }
        // 调用父组件的重置方法，传递保存的项目名称和描述
        this.props.onResetShareStatus(shareTitle, shareDes);
    }

    render () {
        const {
            onCloseModal,
            defaultTitle,
            // eslint-disable-next-line react/prop-types
            blob,
            thumbnail,
            singleVideoPoint,
            isVideoPointUpLimit,
            isVideoChecking
        } = this.props;

        const {
            shareTitle,
            selectedTab,
            shareDes,
            isDesNumLimit,
            bigShow,
            isPublish,
            labels,
            canShareToClass
        } = this.state;

        if (blob) {
            if (!this.videoSrc) {
                this.videoSrc = window.URL.createObjectURL(blob);
            }
        } else if (this.videoSrc) {
            URL.revokeObjectURL(this.videoSrc);
            this.videoSrc = null;
        }
        const videoSrc = this.videoSrc;
        // 优先使用保存的项目名称（来自 state），否则使用 defaultTitle
        const titleToUse = shareTitle || (defaultTitle.length > 20 ? defaultTitle.substring(0, 20) : defaultTitle);
        const defaultTitle_ = titleToUse;
        const Tags = labels.map((label, index) => (<div
            className={classNames(
                label.active ? style.stepLabelItemActive : '',
                style.stepLabelItem
            )}
            key={label.key}
            onClick={this.handelSwitchTagsActive(index)}
        >
            {label.label}
        </div>));
        return (
            <ReactModal
                className={bigShow ? style.bigVideoContainer : style.content}
                // eslint-disable-next-line react/jsx-sort-props
                contentLabel="作品信息"
                isOpen
                // eslint-disable-next-line react/jsx-sort-props
                onRequestClose={this.handleCloseShareModal}
                overlayClassName={style.overlay}
                shouldCloseOnOverlayClick={false}
            >
                {bigShow ? <div className={style.bigVideoContainer} >
                    <video
                        src={videoSrc}
                        controls="controls"
                        x-webkit-airplay="allow"
                        preload="auto"
                        className={style.bigVideo}
                        ref={this.bigVideoRef}
                        disablepictureinpicture="true"
                        controlsList="nodownload"
                    />
                    {/* <div
                        className={style.closeContainer}
                        onClick={this.handleBigVideoClose}
                    >
                        <span className={style.close} />
                    </div> */}
                    <CloseButton onClick={this.handleBigVideoClose} />
                </div> : <div className={(style.modalBodyStep)}>
                    <CloseButton onClick={this.handleCloseShareModal} />
                    {/* <div
                        className={style.bodyTitle}
                    >
                        {'作品信息'}
                    </div> */}
                    {
                        !blob ? <div className={style.shareTop}>
                            <div className={classNames(style.topItem, {[style.topItemActive]: selectedTab === '项目分享'})}>
                                <span onClick={() => {this.clickShareHandle('项目分享')}}>项目分享</span>
                                {selectedTab === '项目分享' ? <div className={style.activeBorder}></div> : null}
                            </div>
                            <div className={classNames(style.topItem, {[style.topItemActive]: selectedTab === '视频录制'})}>
                                <span onClick={() => {this.clickShareHandle('视频录制')}}>视频录制</span>
                                {selectedTab === '视频录制' ? <div className={style.activeBorder}></div> : null}
                            </div>
                        </div>
                        : <div style={{height: '30px'}}></div>
                    }
                    <div className={style.modalBodyWork}>
                        {blob && <div className={style.stepForm}>
                            <p
                                className={style.stepFormLabel}
                            >
                                {'项目预览'}
                            </p>
                            <div className={style.btnAgain}>
                                {<VideoShow
                                    videoSrc={videoSrc}
                                    onClick={this.handleVideoClick}
                                  />}
                                <Button
                                    onClick={this.handleReupload}
                                    className={style.btnUpload}
                                >
                                    重新上传
                                </Button>
                            </div>
                        </div>}
                        <div className={style.stepForm}>
                            <p
                                className={style.stepFormLabel}
                            >
                                {'项目名称'}
                            </p>
                            <input
                                className={style.stepFormInputInline}
                                placeholder="最多输入20个字"
                                defaultValue={defaultTitle_}
                                maxLength={20}
                                onChange={this.handleInputInfo}
                                disabled={isVideoChecking}
                            />
                        </div>
                        <div className={style.stepForm}>
                            <p
                                className={style.stepFormLabel}
                            >
                                {'项目描述'}</p>
                            <textarea
                                className={style.stepFormTextareaBlock}
                                maxLength={50}
                                placeholder="快来看看我的Scratch作品吧！"
                                value={shareDes}
                                onChange={this.handleTextareaInfo}
                                disabled={isVideoChecking}
                            />
                            <span
                                className={classNames(
                                    style.textareaNum,
                                    isDesNumLimit ? style.textareaNumWarning : ''
                                )}
                            >
                                {`${shareDes.length}/50`}
                            </span>
                        </div>
                        {!blob && <div>
                            <div
                                style={{'opacity': canShareToClass === null ? 0 : 1}}
                                className={classNames(isPublish ? style.publishCheck : '', style.isPublish)}
                            >
                                <input
                                    checked={isPublish}
                                    id="isPublish"
                                    type="checkbox"
                                    onChange={this.handleSwitchPublish}
                                />
                                <label htmlFor="isPublish"><span />{canShareToClass ? '同时发布至班级学习空间' : '同时发布至公开社区'}</label>
                                <div className={style.shareTip}>
                                    <span>{canShareToClass ? '作品将发布到您在读的编程班级中（包含开课中、7天内即将开课、已结课7天内的所有在读班级）。老师可能将作品推荐到公开社区，向更多人展示。' : '作品将提交给官方审核，审核通过后将发布到公开社区展示。'}</span>
                                </div>
                            </div>
                            <div className={classNames(style.stepForm, style.stepLabelForm)}>
                                {isPublish && <div>
                                    <div className={style.stepLabelTips}>{'作品标签'}</div>
                                    <div className={style.stepLabelList}>
                                        {Tags}
                                    </div>
                                </div>
                                }
                            </div>
                        </div>}
                        
                        
                    </div>
                    <div className={style.modalFooter}>
                        <Button
                            style={{opacity: canShareToClass === null || isVideoChecking ? 0.7 : 1, cursor: canShareToClass === null || isVideoChecking ? 'not-allowed' : 'pointer'}}
                            className={style.btn}
                            disabled={isVideoChecking || canShareToClass === null}
                            onClick={this.handleData}
                        >
                            {isVideoChecking ? <><div className={style.loadingSpinner} />视频审核中（约60秒）…</> : '上传作品'}
                        </Button>
                    </div>
                    {/* { blob && <div>
                        {isVideoPointUpLimit ? <p className={style.scoreTip}>{'今日获取积分已达上限'}</p> : <p className={style.scoreTip}>{'上传作品 获得'}{singleVideoPoint}{'积分'}</p>}
                    </div>
                    } */}
                </div>
                }
            </ReactModal>
        );
    }
}

FirstStep.propTypes = {
    onResetShareStatus: PropTypes.func,
    defaultTitle: PropTypes.string,
    savedProjectTitle: PropTypes.string,
    savedProjectDesc: PropTypes.string,
    onClick: PropTypes.func,
    onCloseModal: PropTypes.func,
    thumbnail: PropTypes.string,
    // blob: PropTypes.blob
    singleVideoPoint: PropTypes.number,
    isVideoPointUpLimit: PropTypes.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    videoType: PropTypes.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    audioType: PropTypes.bool,
    duration: PropTypes.number,
    isVideoChecking: PropTypes.bool
};

export default FirstStep;
